import * as axios from 'axios/index';

export const updateCart = (productVersionOptionId, quantity, cb = () => {}) => {
  axios
    .put('/api/cart', {
      productVersionOptionId,
      quantity,
    })
    .then(response => cb(response.data));
};

export const removeFromCart = (productVersionOptionId, cb = () => {}) => {
  axios.delete(`/api/cart/${productVersionOptionId}`).then(response => cb(response.data));
};

export const updateWishlist = (productVersionOptionId, quantity, cb = () => {}) => {
  axios
    .put('/api/wishlist', {
      productVersionOptionId,
      quantity,
    })
    .then(response => cb(response.data));
};

export const removeFromWishlist = (productVersionOptionId, cb = () => {}) => {
  axios.delete(`/api/wishlist/${productVersionOptionId}`).then(response => cb(response.data));
};

export const moveToCart = (productVersionOptionId, cb = () => {}) => {
  axios.post(`/api/wishlist/${productVersionOptionId}/move_to_cart`).then(response => cb(response.data));
};

export const moveToWishlist = (productVersionOptionId, cb = () => {}) => {
  axios.post(`/api/cart/${productVersionOptionId}/move_to_wishlist`).then(response => cb(response.data));
};
